import React from 'react';
import MenuText from '../ui/typography/MenuText';
import { Link } from 'gatsby';
import PrimaryButton from '../ui/buttons/PrimaryButton';
import { slide as Menu } from 'react-burger-menu';
import AirCorporateLogo from '../../images/icons/air-corporate-logo.svg';
import AirCorporateLogoWhite from '../../images/icons/air-corporate-logo-white.svg';
import '../../styles/header-navigation.scss';
import { PAGES_ENDPOINTS } from '../../constants/pages-endpoints';
import WhatsappModal from '../common/WhatsappModal';
import WeChatModal from '../common/WeChatModal';
import { COLORS, LINKS } from '../../constants/enum';
import ContactModal from '../common/ContactModal';
import { navigate } from 'gatsby';
export default function HeaderNavigation({ textColor, logosColor }) {
  const handleClick = () => {
    navigate(PAGES_ENDPOINTS.GET_STARTED);
  };
  return (
    <div className="md:static relative flex header-navigation px-6 lg:px-8 mx-auto items-center">
      <div className="handburger-menu">
        <Menu>
          <div>
            <div className="sticky top-0 bg-white h-16">
              <div className="flex flex-row ml-8 items-center pt-4">
                <Link className="flex hover:no-underline mt-2" to="/">
                  <img src={AirCorporateLogo} alt="air-corporate-logo" width="192" height="32" />
                </Link>
              </div>
            </div>

            <div className="mt-6 expand-section">
              <Link to={PAGES_ENDPOINTS.AIR_CORPORATE} className="px-4 py-6 text-medium text-blue-200">
                Switch to Air Corporate
              </Link>
            </div>

            <div className="expand-section">
              <Link to={PAGES_ENDPOINTS.ACCOUNTING_SERVICES} className="px-4 py-6 text-medium text-blue-200">
                Accounting
              </Link>
            </div>
            <div className="expand-section">
              <Link to={PAGES_ENDPOINTS.BLOG} className="px-4 py-6 text-medium text-blue-200">
                Blog
              </Link>
            </div>
            <div className="expand-section">
              <Link to={PAGES_ENDPOINTS.ABOUT_US} className="px-4 py-6 text-medium text-blue-200">
                About Us
              </Link>
            </div>
            <div className="flex md:flex-row justify-center gap-4">
              <ContactModal>
                <div className="md:ml-12 mt-4 text-center">
                  <MenuText
                    title="Contact"
                    textColor="text-blue-200"
                    linkClassName="menu-text-link"
                    imgClassName="menu-text-image"
                    urlLink="?=contact"
                    withDropDown={false}
                  />
                </div>
              </ContactModal>
              <div className="md:mr-6 flex justify-center gap-6 md:ml-12 mt-4">
                <WhatsappModal fill={COLORS?.BLUE500} />
              </div>
              <div className="md:mr-6 flex justify-center gap-6 md:ml-12 mt-4">
                <WeChatModal fill={COLORS?.BLUE500} />
              </div>
            </div>
            <div className="flex md:flex-row justify-center gap-4 md:mt-0 mt-4">
              <div className="md:ml-12 mt-4 text-center">
                <MenuText
                  title="Login"
                  textColor="text-blue-200"
                  linkClassName="menu-text-link"
                  imgClassName="menu-text-image"
                  urlLink={LINKS.login}
                  withDropDown={false}
                />
              </div>

              <div className="md:ml-12 mt-4 text-center">
                <PrimaryButton
                  textColor="text-gray-600"
                  bgColor="hover:bg-white bg-transparent"
                  caption="Sign Up"
                  border="border"
                  borderColor="border-blue-500"
                  fontSize="12px"
                  fontWeight="text-medium"
                  padding=".5rem 1.35rem"
                  lineHeight="15px"
                  onClick={handleClick}
                />
              </div>
            </div>
          </div>
        </Menu>
      </div>

      <div className="mr-auto">
        {!logosColor ? (
          <Link className="flex hover:no-underline" to="/">
            <img src={AirCorporateLogo} alt="air-corporate-logo" width="192" height="32" />
          </Link>
        ) : (
          <Link className="flex hover:no-underline" to="/">
            <img src={AirCorporateLogoWhite} alt="air-corporate-logo" width="192" height="32" />
          </Link>
        )}
      </div>

      <div className="ml-auto items-center navigation-items-container">
        <div className="menu-text-container navigation-items-container items-center">
          <MenuText
            title="Switch to Air Corporate"
            textColor={textColor}
            urlLink={PAGES_ENDPOINTS.AIR_CORPORATE}
            withDropDown={false}
            linkClassName="menu-text-link"
            imgClassName="hidden"
          />
          <MenuText
            title="Accounting"
            textColor={textColor}
            withDropDown={false}
            linkClassName="menu-text-link"
            urlLink={PAGES_ENDPOINTS.ACCOUNTING_SERVICES}
            imgClassName="hidden"
          />
          <MenuText
            title="Blog"
            textColor={textColor}
            withDropDown={false}
            linkClassName="menu-text-link"
            urlLink={PAGES_ENDPOINTS.BLOG}
            imgClassName="hidden"
          />
          <MenuText
            title="About Us"
            textColor={textColor}
            linkClassName="menu-text-link"
            imgClassName="hidden"
            urlLink={PAGES_ENDPOINTS.ABOUT_US}
            withDropDown={false}
          />
          <ContactModal>
            <MenuText
              title="Contact"
              textColor={textColor}
              linkClassName="menu-text-link"
              imgClassName="menu-text-image"
              urlLink="?=contact"
              withDropDown={false}
            />
          </ContactModal>
          <div className="mr-6 flex gap-6">
            <WhatsappModal fill={logosColor ? logosColor : COLORS?.BLUE500} />
            <WeChatModal fill={logosColor ? logosColor : COLORS?.BLUE500} />
          </div>
          <MenuText
            title="Login"
            textColor={textColor}
            linkClassName="menu-text-link mx-2"
            imgClassName="menu-text-image"
            urlLink={LINKS.login}
            withDropDown={false}
          />
          <PrimaryButton
            className="ml-2"
            textColor={textColor ? `${textColor} hover:text-gray-700` : 'text-white hover:text-gray-700'}
            bgColor="hover:bg-white bg-transparent"
            caption="Sign Up"
            border="border"
            borderColor={logosColor ? 'border-white' : 'border-blue-500'}
            fontSize="12px"
            fontWeight="text-medium"
            padding=".5rem 1.35rem"
            lineHeight="15px"
            onClick={handleClick}
          />
        </div>
      </div>
    </div>
  );
}
